import { lazy, Suspense } from 'react';
import { Outlet, createRoute } from '@tanstack/react-router';

import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import { rootRoute } from './root';

const ProducerDetails = lazy(() => import('src/sections/producers/producer-details/view'));

// Producers routes
const producersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'producers',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    </AppAuthGuard>
  ),
});

const producerDetailsRoute = createRoute({
  getParentRoute: () => producersRoute,
  path: '$producerId',
  component: ProducerDetails,
});

export const producersRouteTree = producersRoute.addChildren([producerDetailsRoute]);


